import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './NewVisit.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';
var customer_XHR={'abort' : ()=>{}};
var singleCustomer_DOM;

class NewVisit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company : '',
      person : '',
      address : '',
      gst : '',
      phone :'',
      districts : [],
      district :'',
      newvisits : [],
      customer_id : ''
    }
    this.formChange = this.formChange.bind(this);
  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    singleCustomer_DOM = $(".single_customer_details").clone();
    $(".single_customer_details").remove();
    this.getNewVisitDistricts();    
    var obj_this = this;

    $(".customer_suggestions_container").on("mousedown",".single_customer_details",function(){
      $(".customer_suggestions_container").empty().css("display","none");
      const customer_id = $(this).attr("customer_id");
      obj_this.context.loading(1);
      const url = `${process.env.REACT_APP_SSS}/api/new/visit/customer/details`;
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          customer_id : customer_id
        },
        type : "POST"
      }).done(function(return_data){
        var option = obj_this.state.districts.filter(item => item.value == return_data.customer.district_id);
        // console.log(option);
        option = option[0]?option[0]:{};
        obj_this.setState({
          company : return_data.customer.company,
          person : return_data.customer.person,
          phone : return_data.customer.phone,
          gst : return_data.customer.gst,
          district : option,
          address : return_data.customer.address,
          customer_id : customer_id,
        });
        obj_this.context.loading(0);
      });
    })

    $(".company").on("focusout",function(e){
      console.log(e.target);
      $(".customer_suggestions_container").empty().css("display","none");
    });
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  companyChange(e){
    $(".customer_suggestions_container").empty();
    this.setState({
      [e.target.name] : e.target.value
    });
    
    if(!e.target.value){
      this.setState({
        person : '',
        phone : '',
        gst : '',
        district : '',
        address : '',
        customer_id : '',
      });
      $(".customer_suggestions_container").css("display","none");
      return;
    }
    // alert(e.target.value);
    if(!this.state.customer_id){
      this.setState({
        person : '',
        phone : '',
        gst : '',
        district : '',
        address : '',
        customer_id : '',
      });
    }
    this.context.loading(1);
    const obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/search/new/visit/customer`;
    customer_XHR.abort();
    customer_XHR = $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        company : e.target.value
      },
      type : "POST"
    }).done(function(return_data){
      if(return_data.customers.length){
        for(var i=0;i<return_data.customers.length;i++){
          var node = singleCustomer_DOM.clone();
          node.find(".customer_name").html(return_data.customers[i]['company']);
          node.find(".customer_phone_no").html(return_data.customers[i]['phone']);
          node.attr("customer_id",return_data.customers[i]['id']);
          $(".customer_suggestions_container").append(node);
        }
        $(".customer_suggestions_container").css("display","block");
        obj_this.context.loading(0);
      }else{
        $(".customer_suggestions_container").css("display","none");
        obj_this.context.loading(0);
      }
    });
  }

  customerTypeChange(e) {
    this.getScheduleCustomers(e.target.value);
    this.setState({
      customer_type: e.target.value
    });
  }

  getNewVisitDistricts(){
    const url = `${process.env.REACT_APP_SSS}/api/get/districts`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          districts : return_data.districts,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  districtChange(option){
    // console.log(option);
    this.setState({
      district : option
    }); 
  }

  formSubmit(e){
    e.preventDefault();
    // console.log(this.state);
    // return;
    const newvisits = this.state;
    const url = `${process.env.REACT_APP_SSS}/api/save/visit/customer`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        newvisits : newvisits
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({ 
            newvisits : []
        });
        alert("New Visit Customer saved");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/home');
      }
      else if(return_data.status == "exists"){
        alert("Customer already exists");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/home');
      }
      else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_schedule_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Customer Visit</div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="customer_details_container blocks">
            <div className="customer_container">

            <div className="input_label">Company</div>
              <input className="company input custom_input"
                type="text"
                name="company"
                value={this.state.company}
                onChange={e => this.companyChange(e)}
                required
                autoComplete="off"
              />
              <div className="customer_suggestions_container">
                    <div className="single_customer_details">
                      <div className="customer_name"></div>
                      <div className="customer_phone_no"></div>
                    </div>
                  </div>
              </div>
            <div className="input_label">Person</div>
              <input className="billing_contact_no input custom_input"
                type="text"
                name="person"
                value={this.state.person}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
            <div className="input_label">Phone</div>
              <input className="billing_contact_no input custom_input"
                type="tel"
                name="phone"
                value={this.state.phone}
                onChange={this.formChange}
                pattern="^[0]?[1-9][0-9]{9}$"
                required
                autoComplete="off"
              />
            <div className="input_label">VATIN</div>
              <input className="billing_contact_no input custom_input"
                type="text"
                name="gst"
                value={this.state.gst}
                onChange={this.formChange}
                autoComplete="off"
              />
            <div className="input_label">Address</div>
              <textarea className="input billing_address custom_input" 
                name="address"
                value={this.state.address}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
            <div className="input_label">Wilayat</div>
              <Select 
                options={this.state.districts}  
                value ={this.state.district}
                className="customer" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.districtChange(e)}
                required
                
              />
            </div>
            <button type="submit" className="submit_button">
            <i className="far fa-save"></i> {this.state.customer_id?"Update":"Create"}
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewVisit;
NewVisit.contextType = MyContext;
